import Chart from "react-apexcharts";
import { Skeleton } from "@mui/material";
import { DashCard } from "./DashCard";
import { colors, fontFamily } from "../../data/tokens";
import { MonthlySeries } from "./useDashboardData";

// Eixo em valores compactos ("120 mil", "1,2 mi"); tooltip em R$ cheio
const compactBRL = (v: number) =>
  v >= 1_000_000
    ? `${(v / 1_000_000).toLocaleString("pt-BR", {
        maximumFractionDigits: 1,
      })} mi`
    : v >= 1_000
    ? `${Math.round(v / 1_000).toLocaleString("pt-BR")} mil`
    : String(Math.round(v));
const fullBRL = (v: number) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Receita (R$) por mês — últimos 12 meses, só transações de receita
// (fase 2 dos KPIs, endpoint /transactions/stats/overview)
export function RevenueBarChart({
  monthly,
}: {
  monthly: MonthlySeries | null;
}) {
  return (
    <DashCard title="Receita por mês (R$, últimos 12 meses)">
      {!monthly ? (
        <Skeleton variant="rounded" height={280} />
      ) : (
        <Chart
          type="bar"
          height={300}
          series={[{ name: "Receita", data: monthly.values }]}
          options={{
            chart: { fontFamily, toolbar: { show: false } },
            colors: [colors.success],
            plotOptions: { bar: { borderRadius: 4, columnWidth: "55%" } },
            dataLabels: { enabled: false },
            xaxis: { categories: monthly.labels },
            yaxis: { labels: { formatter: (v: any) => compactBRL(Number(v)) } },
            grid: { borderColor: colors.neutral200 },
            tooltip: { y: { formatter: fullBRL } },
          }}
        />
      )}
    </DashCard>
  );
}
